"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typography = void 0;

var _colors = require("./colors.theme");

var typography = {
  defaultColors: {
    withLightBg: _colors.colors.primaryFont,
    withDarkBg: _colors.colors.white
  },
  baseFontSize: {
    xxs: '16px',
    xs: '16px',
    sm: '17px',
    md: '18px',
    lg: '19px',
    xl: '19px'
  },
  text: {
    normal: {
      fontSize: {
        xxs: '1rem'
      },
      lineHeight: {
        xxs: '1.5em'
      }
    },
    small: {
      fontSize: {
        xxs: '.869rem',
        xs: '.833rem'
      },
      lineHeight: {
        xxs: '1.2em'
      }
    },
    xSmall: {
      fontSize: {
        xxs: '.756rem',
        xs: '.694rem'
      },
      lineHeight: {
        xxs: '1.2em'
      }
    },
    xxSmall: {
      fontSize: {
        xxs: '.657rem',
        xs: '.578rem'
      },
      lineHeight: {
        xxs: '1.2em'
      }
    }
  },
  heading: {
    super1: {
      fontSize: {
        xxs: '3.8004328558rem',
        xs: '4.90606726349rem'
      },
      lineHeight: {
        xxs: '1.1em'
      },
      letterSpacing: {
        xxs: '-1.35',
        xs: '-1.35',
        sm: '-1.5'
      }
    },
    super2: {
      fontSize: {
        xxs: '3.22070581rem',
        xs: '4.1576841216rem'
      },
      lineHeight: {
        xxs: '1.13em'
      },
      letterSpacing: {
        xxs: '-1.3',
        xs: '-1.3',
        sm: '-1.4'
      }
    },
    super3: {
      fontSize: {
        xxs: '2.72941170341rem',
        xs: '3.52346112rem'
      },
      lineHeight: {
        xxs: '1.15em'
      },
      letterSpacing: {
        xxs: '-1.225',
        xs: '-1.225',
        sm: '-1.275'
      }
    },
    h1: {
      fontSize: {
        xxs: '2.3130607656rem',
        xs: '2.985984rem'
      },
      lineHeight: {
        xxs: '1.18em'
      },
      letterSpacing: {
        xxs: '-1.2',
        xs: '-1.2',
        sm: '-1.25'
      }
    },
    h2: {
      fontSize: {
        xxs: '2.0113571875rem',
        xs: '2.48832rem'
      },
      lineHeight: {
        xxs: '1.19em'
      },
      letterSpacing: {
        xxs: '-0.75'
      }
    },
    h3: {
      fontSize: {
        xxs: '1.74900625rem',
        xs: '2.0736rem'
      },
      lineHeight: {
        xxs: '1.2em'
      },
      letterSpacing: {
        xxs: '-0.5'
      }
    },
    h4: {
      fontSize: {
        xxs: '1.520875rem',
        xs: '1.728rem'
      },
      lineHeight: {
        xxs: '1.2em'
      },
      letterSpacing: {
        xxs: '-0.3'
      }
    },
    h5: {
      fontSize: {
        xxs: '1.3225rem',
        xs: '1.44rem'
      },
      lineHeight: {
        xxs: '1.2em'
      },
      letterSpacing: {
        xxs: '-0.25'
      }
    },
    h6: {
      fontSize: {
        xxs: '1.15rem',
        xs: '1.2rem'
      },
      lineHeight: {
        xxs: '1.2em'
      }
    }
  }
};
exports.typography = typography;